export var DIVIDER_CLASS_PREFIX = 'Divider';